import type { ImageSelectorAsset } from '@amityeko/design-system/dist/elements/image-selector/types';
import type { ChipsSelectionOption } from '@amityeko/design-system/dist/elements/chips-selection/types';

export const mockGradientData: ImageSelectorAsset[] = [
  {
    type: 'gradient',
    id: '1',
    fromColor: '#3DDBD9',
    toColor: '#0072C3',
  },
  {
    type: 'gradient',
    id: '2',
    fromColor: '#FF7EB6',
    toColor: '#8A3FFC',
  },
  {
    type: 'gradient',
    id: '3',
    fromColor: '#F8A34D',
    toColor: '#D02670',
  },
  {
    type: 'gradient',
    id: '4',
    fromColor: '#33B1FF',
    toColor: '#8A3FFC',
  },
  {
    type: 'gradient',
    id: '5',
    fromColor: '#9FDF9E',
    toColor: '#007D79',
  },
  {
    type: 'gradient',
    id: '6',
    fromColor: '#2C2C2C',
    toColor: '#0E0E0E',
  },
];

export const colorData = [
  '#FFFFFF',
  '#000000',
  '#9E9E9E',
  '#33ccc7',
  '#0494fb',
  '#6604fb',
  '#fb0489',
  '#fb6c04',
];

export const chipList: ChipsSelectionOption[] = [
  {
    id: 'text',
    value: 'text',
    label: 'Text',
    selectionColor: '#1F7A64',
  },
  {
    id: 'video',
    value: 'video',
    label: 'Video',
    selectionColor: '#1F7A64',
  },
];

export const RECOGNITION_TYPE = {
  TEXT: 'text',
  VIDEO: 'video',
  AUDIO: 'audio',
};
